module.exports = __webpack_public_path__ + "static/media/premeraLogo2 - no alaska.60dd92cd.png";